var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mark"},[_c('div',{staticClass:"mark-circle"},[_c('img',{attrs:{"src":require("../assets/gg.svg"),"alt":"","aria-hidden":"true"}})]),_c('div',{staticClass:"mark-name"},[_vm._v("geek"),_c('span',[_vm._v("group")])])])
}]

export { render, staticRenderFns }